import { Field, Form, Formik } from "formik";
import { MouseEventHandler } from "react";

import { UserLocation } from "custom-models";

import usStates from "shared/utils/usStates";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import SelectInput from "components/customInputs/SelectInput";
import TextInput from "components/customInputs/TextInput";

type LocationFormProps = {
  location: UserLocation;
  onClose: MouseEventHandler<HTMLButtonElement>;
  onSubmit: Function;
  disableSubmit?: boolean;
};

const LocationForm = ({
  location,
  onClose,
  onSubmit,
  disableSubmit = false,
}: LocationFormProps) => {
  return (
    <Formik
      initialValues={{
        ...location,
      }}
      enableReinitialize
      onSubmit={(values) => {
        if (disableSubmit) return;

        onSubmit(values);
      }}
    >
      {({ resetForm, dirty }) => (
        <Form className="AdminPanelForm">
          <div className="panelContainer">
            <fieldset className="panelContainer__section">
              <legend className="panelContainer__section--title">
                Contact Information
              </legend>
              <div className="panelContainer__inputGroup">
                <Field name="phone1">
                  {({ field }: any) => (
                    <TextInput
                      type="tel"
                      label="Phone"
                      id="phone1"
                      {...field}
                      disabled={disableSubmit}
                    />
                  )}
                </Field>
                <Field name="phone2">
                  {({ field }: any) => (
                    <TextInput
                      type="tel"
                      label="Phone 2"
                      id="phone2"
                      {...field}
                      disabled={disableSubmit}
                    />
                  )}
                </Field>
              </div>
            </fieldset>
            <fieldset className="panelContainer__section">
              <legend className="panelContainer__section--title">
                Address
              </legend>
              <Field name="street">
                {({ field }: any) => (
                  <TextInput
                    label="Street Line 1"
                    id="street"
                    {...field}
                    required
                    disabled={disableSubmit}
                  />
                )}
              </Field>
              <Field name="street2">
                {({ field }: any) => (
                  <TextInput
                    label="Street Line 2"
                    id="street2"
                    {...field}
                    disabled={disableSubmit}
                  />
                )}
              </Field>
              <div className="panelContainer__inputGroup">
                <Field name="city">
                  {({ field }: any) => (
                    <TextInput
                      label="City"
                      id="city"
                      {...field}
                      disabled={disableSubmit}
                    />
                  )}
                </Field>
                <Field name="state">
                  {({ field }: any) => (
                    <SelectInput
                      label="State"
                      options={Object.keys(usStates).map((abbr) => ({
                        label: usStates[abbr],
                        value: abbr,
                      }))}
                      {...field}
                      disabled={disableSubmit}
                    />
                  )}
                </Field>
                <Field name="zipcode">
                  {({ field }: any) => (
                    <TextInput
                      label="Zip Code"
                      id="zipcode"
                      {...field}
                      required
                      disabled={disableSubmit}
                    />
                  )}
                </Field>
              </div>
            </fieldset>
          </div>
          <footer>
            <PathologyWatchButton onClick={onClose}>
              Cancel
            </PathologyWatchButton>

            <div className="panelContainer__inputGroup">
              <PathologyWatchButton
                onClick={() => {
                  resetForm();
                }}
                disabled={!dirty}
              >
                Discard Changes
              </PathologyWatchButton>
              <PathologyWatchButton
                type="submit"
                color="green"
                disabled={!dirty || disableSubmit}
              >
                Save
              </PathologyWatchButton>
            </div>
          </footer>
        </Form>
      )}
    </Formik>
  );
};

export default LocationForm;
